import { MouseEvent } from 'react';
import { useTranslate } from 'i18n/useTranslationModules';
import { focusMainContent } from 'utils/focus-main-content';

import './skip-link.scss';

export const SkipLink = (): JSX.Element => {
	const { t } = useTranslate('homepage');

	const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();
		focusMainContent();
	};

	return (
		<a href="#main-content" className="skip-link" onClick={handleClick}>
			{t('Skip to content', 'Skip to content')}
		</a>
	);
};
